import { type VoidFunctionComponent } from 'react';

import { icons } from '../../../generic';
import Button, { BUTTON_SIZE, LoaderButton } from '../../../generic/Button';

import styles from './Buttons.module.less';

type Props = {
  /**
   * Whether the snippet is rejected.
   */
  isRejected: boolean;
  /**
   * Whether it is possible to convert this snippet to a vendored dependency
   */
  isConversionPossible: boolean;
  /**
   * Whether a snippet is currently being rejected.
   */
  isRejecting?: boolean;
  /**
   * Handler when the reject button is clicked.
   */
  onRejectClick: () => void;
  /**
   * Whether a snippet is currently being unrejected.
   */
  isUnrejecting?: boolean;
  /**
   * Handler when the stop rejecting button is clicked.
   */
  onUnrejectClick: () => void;
  /**
   * Handler when "Download" button is clicked.
   */
  onDownloadClick: () => void;
  /**
   * Handler when "Convert" button is clicked.
   */
  onConvertClick: () => void;
};

/**
 * Action buttons for the SnippetsDrawer
 */
const SnippetsDrawerButtons: VoidFunctionComponent<Props> = ({
  isRejected,
  isConversionPossible,
  isRejecting,
  onRejectClick,
  isUnrejecting,
  onUnrejectClick,
  onDownloadClick,
  onConvertClick,
}) => (
  <div className={styles.buttons}>
    {isRejected ? (
      <LoaderButton
        icon={icons.banOutline}
        type="secondary"
        size={BUTTON_SIZE.MEDIUM}
        onClick={onUnrejectClick}
        isLoading={isUnrejecting}
      >
        Stop Rejecting
      </LoaderButton>
    ) : (
      <LoaderButton
        icon={icons.xCircle}
        type="secondary"
        size={BUTTON_SIZE.MEDIUM}
        onClick={onRejectClick}
        isLoading={isRejecting}
      >
        Reject
      </LoaderButton>
    )}
    <Button
      icon={icons.downloadRegular}
      type="secondary"
      size={BUTTON_SIZE.MEDIUM}
      onClick={onDownloadClick}
    >
      Download Match Data
    </Button>
    { isConversionPossible &&
    <Button
      icon={icons.arrowRightFromArc}
      type="secondary"
      size={BUTTON_SIZE.MEDIUM}
      onClick={onConvertClick}
    >
      Convert to Vendored Dependency
    </Button>}
  </div>
);

export default SnippetsDrawerButtons;
